module.exports = __webpack_public_path__ + "static/media/fyo.bbaf5d07.jpg";